import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { invitaciones2018 } from '../../json/invitaciones2018';
import { invitaciones2019 } from '../../json/invitaciones2019';
import { invitaciones2022 } from '../../json/invitaciones2022';
import { invitaciones2025 } from '../../json/invitaciones2025';
import Invitaciones from './Invitaciones';

const InvitacionesAnteriores = () => {
    
    const  { ciclo }  = useParams();
        
    const [
      invitaciones, setInvitaciones
      ] = useState ( [] );

    const selInvitaciones = async () => {     
    switch (ciclo) {
      case '2018':
        setInvitaciones (invitaciones2018)
        break
      case '2019':
        setInvitaciones (invitaciones2019)
        break
      case '2022':
        setInvitaciones (invitaciones2022)
        break
      case '2025':
        setInvitaciones (invitaciones2025)
        break
            }
    }

  useEffect(() => {
    selInvitaciones();
    window.scrollTo(0, 0);

  }, [ ciclo ]);

    return(        
        <>            
            <br />
            <Invitaciones ciclo={ciclo} invitaciones={ invitaciones } />
            
        </>
    )
}

export default InvitacionesAnteriores